import {
    createRouter,
    createWebHistory,
    LocationAsRelativeRaw,
    RouteLocationNormalizedGeneric,
    RouteLocationNormalizedLoadedGeneric,
    Router, RouteRecordRaw
} from 'vue-router'
import returns from './routes/returns';
import acknowledgement from './routes/acknowledgement';
import address from './routes/address';
import approval from './routes/approval';
import auth from './routes/auth';
import catalog from './routes/catalog';
import errors from './routes/errors';
import helpdesk from './routes/helpdesk';
import impersonation from './routes/impersonation';
import main from './routes/main';
import order from './routes/order';
import privacy from './routes/privacy';
import products from './routes/products';
import quiz from './routes/quiz';
import survey from './routes/survey';
import surveys from './routes/surveys';
import terms from './routes/terms';
import tunnel from './routes/tunnel';
import {RouteMetaProcessor, RouterMetaProcessorResult} from '@/global/types/router';
import {
    processRequireRedirect,
    processRequireAuth,
    processRequireGuest,
    processRequireUserAcknowledgement,
    processRequireUserPermissions,
    processRequireUserData
} from '@/router/meta';

const routes = []
    .reduce((result, arr) => result.concat(arr), []);

const router: Router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: ([] as RouteRecordRaw[]).concat(
        auth,
        order,
        survey,
        errors,
        products,
        catalog,
        quiz,
        address,
        tunnel,
        surveys,
        returns,
        approval,
        main,
        acknowledgement,
        helpdesk,
        impersonation,
        privacy,
        terms
    ) as RouteRecordRaw[]
});

router.beforeEach(async (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedLoadedGeneric) => {

    const handlers: RouteMetaProcessor[] = [
        processRequireRedirect, // It's important to keep this ordering
        processRequireGuest,
        processRequireAuth,
        processRequireUserAcknowledgement,
        processRequireUserPermissions,
        processRequireUserData,
    ]

    for (let i = 0; i < handlers.length; i++) {
        const redirect: RouterMetaProcessorResult = await handlers[i](to, from);

        if (redirect) {

            if ('string' === typeof redirect) {

                // External redirect: leave the app and cancel this navigation (a returned string would be an in-app path)
                window.location.href = redirect;

                return false;
            }

            // Route access is denied
            return redirect as LocationAsRelativeRaw;
        }
    }

    // All checks have been passed. So, navigate to destination route
    return true;
});

export default router
